export const setTransactions = (state, transactions) => {
    state.transactions = transactions;
};
